import { Interval } from './animation'
import Easing from './easing'
import { CSSNames, StyleNames } from './helpers'

/**
 * Adding a parallax scrolling effect to DOM elements.
 * Either add the DOM element to the `parallaxObjects` array
 * or give it a `.parallax` class (only works on page load)
 */
export let parallaxObjects = []

function initializeParallax() {
	const elements = document.body.querySelectorAll('.parallax')
	for (const element of elements) {
		parallaxObjects.push(element)
	}

	onScroll()
}

function animate() {
	let animating = 0

	if (animating > 0) {
		requestAnimationFrame(animate)
	}
}

function rangesCollide(left, right) {
	return left[0] <= right[1] && right[0] <= left[1]
}

function onScroll() {
	// First check whether the carousels are visible.
	let scrollY = window.pageYOffset;
	const visibleRange = [scrollY, scrollY + innerHeight]

	for (const element of parallaxObjects) {
		// Find document.body.
		let parent = element
		let offsetY = parent.offsetTop

		while (parent != document.body) {
			parent = parent.parentNode
			offsetY += parent.offsetTop
		}

		const elementRange = [
			element.offsetTop + offsetY,
			element.offsetTop + offsetY + element.offsetHeight
		]

		const offset = visibleRange[0] - elementRange[0]
		element.style.transform = `translateY(${offset * 0.4}px)`
	}
}

document.addEventListener('scroll', onScroll)
document.addEventListener('DOMContentLoaded', initializeParallax)